module.exports = __webpack_public_path__ + "img/function_0_param_0_result.f7ed0e52.png";